import { FadeUp, Eyebrow } from "./motion";

const STEPS = [
  { num: "01", title: "Book a free site visit", desc: "Pick a time slot — our specialist comes to your home, office or hotel at zero cost." },
  { num: "02", title: "Samples & exact measurement", desc: "We bring fabric swatches to your doorstep and measure each window precisely." },
  { num: "03", title: "Select your curtain type", desc: "Choose between blackout, sheer, motorized or roller blinds — or let our experts advise." },
  { num: "04", title: "Installation in 1–3 days", desc: "Our team produces and installs your custom curtains within 1 to 3 working days." },
];

export default function HowItWorks() {
  return (
    <section id="process" data-testid="process-section" className="py-20 sm:py-28 lg:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16">
        <FadeUp>
          <Eyebrow className="mb-4">How it works</Eyebrow>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.12] text-slate-900 max-w-2xl">
            Elegant curtains, delivered <span className="italic text-reef">in four effortless steps.</span>
          </h2>
          <p className="mt-5 max-w-xl text-base sm:text-lg text-slate-600 leading-relaxed">
            From the first click to perfectly hung curtains — every step is taken care of by the
            Reef Deco team. No showroom visit required.
          </p>
        </FadeUp>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {STEPS.map((s, i) => (
            <FadeUp key={s.num} delay={i * 0.09}>
              <div
                data-testid={`manifesto-chapter-${i + 1}`}
                className="group h-full bg-white border border-sand-border rounded-2xl p-6 transition-all duration-300 hover:-translate-y-1.5 hover:border-reef/40 hover:shadow-[0_24px_50px_-24px_rgba(134,95,52,0.25)]"
              >
                <p className="font-mono text-4xl text-reef/20 group-hover:text-reef transition-colors duration-300">
                  {s.num}
                </p>
                <h3 className="mt-5 font-serif text-xl text-slate-900 leading-snug">{s.title}</h3>
                <p className="mt-3 text-sm text-slate-600 leading-relaxed">{s.desc}</p>
              </div>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
}
